import { resolvePublicEnv } from './runtimeEnv';

// Single source of truth for Fresh & Homely store details.
// Values are the ones already published on the site — do not change them here
// without confirming against the live store information.
export const STORE = {
  name: 'Fresh & Homely',
  phone: '+91 90194 07023',
  phoneHref: 'tel:+919019407023',
  address:
    'Shop No. 1 and 2, No.12, Bhartiya City Back Gate Rd, Devin Paradise Enclave, Nagareshwara - Nagenahalli, Bengaluru, Karnataka 560077',
  mapsUrl:
    'https://www.google.com/maps/search/?api=1&query=Fresh+%26+Homely+Shop+No.+1+and+2+Bhartiya+City+Back+Gate+Rd+Devin+Paradise+Enclave+Bengaluru',
};

// Canonical metadata must identify the public site rather than whichever
// preview, S3, or container origin happens to serve the current build.
export const SITE_ORIGIN = (
  resolvePublicEnv(
    'REACT_APP_SITE_ORIGIN',
    process.env.REACT_APP_SITE_ORIGIN,
    'https://freshandhomely.com',
  )
).replace(/\/+$/, '');

// Social profiles, from deployment configuration only — never hardcoded here.
// Runtime values (window.__ENV__, written by the container entrypoint) use the
// shared EXPO_PUBLIC_* names; the build-time fallback is the REACT_APP_* alias
// that .env maps onto those same values (CRA only embeds REACT_APP_* names).
const INSTAGRAM_URL = resolvePublicEnv(
  'EXPO_PUBLIC_ABOUT_INSTAGRAM_URL',
  process.env.REACT_APP_ABOUT_INSTAGRAM_URL,
);
const WHATSAPP = resolvePublicEnv('EXPO_PUBLIC_ABOUT_WHATSAPP', process.env.REACT_APP_ABOUT_WHATSAPP);

/** An http(s) URL, or null — a malformed value never becomes a link. */
const safeUrl = (value) => {
  try {
    const url = new URL(value);
    return url.protocol === 'https:' || url.protocol === 'http:' ? url.toString() : null;
  } catch {
    return null;
  }
};

/**
 * The configured WhatsApp contact as a link: a full URL is used as given; a
 * phone number (digits, optionally with +, spaces or dashes) becomes a
 * wa.me chat link. Anything else yields null, so no broken link renders.
 */
export const whatsappHref = (value) => {
  if (!value) return null;
  if (/^https?:\/\//i.test(value)) return safeUrl(value);
  const digits = value.replace(/[\s()+-]/g, '');
  return /^\d{8,15}$/.test(digits) ? `https://wa.me/${digits}` : null;
};

export const SOCIAL_LINKS = {
  instagram: INSTAGRAM_URL ? safeUrl(INSTAGRAM_URL) : null,
  whatsapp: whatsappHref(WHATSAPP),
};

// Customer app download links — configured per environment, validated to HTTPS.
const ANDROID_APP_URL = resolvePublicEnv(
  'REACT_APP_CUSTOMER_APP_ANDROID_URL',
  process.env.REACT_APP_CUSTOMER_APP_ANDROID_URL,
);
const IOS_APP_URL = resolvePublicEnv(
  'REACT_APP_CUSTOMER_APP_IOS_URL',
  process.env.REACT_APP_CUSTOMER_APP_IOS_URL,
);

export const APP_STORE_LINKS = {
  android: ANDROID_APP_URL ? safeUrl(ANDROID_APP_URL) : null,
  ios: IOS_APP_URL ? safeUrl(IOS_APP_URL) : null,
};

// Product ranges the store actually sells, mirroring the homepage Categories
// section. Kept here so the Support page can answer "what do you offer?"
// without restating the list in prose that can drift out of sync.
export const PRODUCT_RANGES = [
  'Freshwater Fish',
  'Sea Fish',
  'Dairy Products',
  'Meat',
  'Grocery Essentials',
];
